import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import TextareaAutosize from 'react-textarea-autosize';
import ListenAudio from "../../../../components/Audio/ListenAudio";
import { useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import AnswerDropDown from "../component/AnswerDropDown";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import useForm from "../../../../hooks/useForm";
import URLS from "../../../../API/Axios/URLS";
import GenericQuestionModal from "../Modal/GenericQuestionModal/GenricQuestionModal";

function MapQuestion({question, answer, setAnswer}){
    return (
        <div className={"w-2/3 flex flex-col gap-2 "}>
            <ListenAudio audio={question?.audioUrl} className={"flex-1"}
                         showPerson={true}
            />
            <div className={"flex flex-1 items-center w-full flex-col gap-4"}>
                <TextareaAutosize
                    minRows={2}
                    placeholder="Write your answer here"
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}

                    className="w-full md:w-3/4 rounded-lg border-2 text-black-2 dark:text-white border-b-graydark bg-white py-2 px-2 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                ></TextareaAutosize>
                <div className={"flex w-full md:w-3/4 flex-row-reverse"}>
                    Word Count : {answer.trim().length!==0? answer.trim().split(" ").length :"0"}
                </div>
            </div>
        </div>
    )
}

export default function ListenAndType({className, ...props}) {
    const {question, questionActions} = useQuestion()
    const [showModal, setShowModal] = useState(false)
    const {id} = useParams()
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: "",
        time: 0
    })
    const [response, setResponse] = useState(null)

    function submitAnswer() {
        actions.post(URLS.genericQuestionView, (data) => {
            let totalTimeInSec = (Date.now() - data.time) / 1000
            // remove decimal points
            totalTimeInSec = Math.floor(totalTimeInSec)

            return {
                ...data,
                time: totalTimeInSec
            }
        }).then(response => {
            setResponse(response?.data)
            setShowModal(true)
            setFormData({
                time: 0
            })
        })

    }


    useEffect(() => {
        questionActions.loadQuestions(id)
    }, [id])



    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader  {...question}
                             timeLimit={question?.timeLimit && question?.timeLimit + 5000}

            />
            <GenericQuestionModal
                result={response}
                showModal={showModal} setShowModal={setShowModal}/>

            <div className={" flex flex-col items-center p-2 py-8 justify-center gap-8"}>

                <MapQuestion question={question} answer={form?.answer} setAnswer={(ans)=>{
                    setFormData({
                        answer: ans
                    })
                }}/>

                <FormNoneFieldErrors errors={error?.answer || error?.non_field_errors || error?.time}/>
            </div>
            <QuestionFooter className={"mx-4 my-2"}
                            loading={loading}
                            disabled={!!response}
                            onClickSubmit={submitAnswer}

            />


            <AnswerDropDown
                className={" mt-4 "}
                headerTitle={"Show Answer"}
                justifications={question?.transcript}
            />
        </div>

    )
}
